import { render, staticRenderFns } from "./businessOperations.vue?vue&type=template&id=0c3452fa"
import script from "./businessOperations.vue?vue&type=script&lang=js"
export * from "./businessOperations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports